import React, { useState } from "react";
import { Box } from "@mui/material";

import { ContactCommentType, ContactComment } from "../../../interfaces/DTO/crm/contactComment";
import { RichTextDisplayList } from "../../../shared/RichTextDisplayList";
import { useAuthStore } from "../../../stores/authStore";
import { useContactCommentsByContactId, useCreateContactComment, useDeleteContactComment, usePartialUpdateContactComment } from "../../../hooks/crm/useContactComments";
;

interface Props {
  contactId: number;
  type: ContactCommentType;
}

export const ContactCommentsList: React.FC<Props> = ({ contactId, type }) => {
    const user = useAuthStore((state) => state.user);
    const { data: allComments = [] } = useContactCommentsByContactId(contactId);
    const create = useCreateContactComment();
    const remove = useDeleteContactComment();
    const update = usePartialUpdateContactComment();
  
    const comments = allComments.filter(
      (c) => c.comment_type === type
    );

  const handleCreate = (newValue: string) => {
    if (!newValue.trim()) return;

    const newComment = new ContactComment({
      contact_id: contactId,
      user_id: user?.id,
      comment_type: type,
      content: newValue,
    });

    create.mutate(newComment)
  };

  const handleDelete = (id: number) => {
    remove.mutate(id);
  };

  const handleEdit = (id: number, newValue: string) => {
    update.mutate({ id, fields: { content: newValue } });
  };

  return (
    <Box sx={{ p: 2,width: "100%" }}>
      <RichTextDisplayList
        items={comments}
        enableNewItem={true}
        onNewSave={handleCreate}
        isNewSaving={create.isPending}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </Box>
  );
};
